import { gql } from '@apollo/client';
import { USER_FRAGMENT } from 'gql';

export default gql`
  mutation MigrateArqamUser($input: MigrateArqamUserInput!) {
    migrateArqamUser(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;
